WS <template>
  <div class="BasePannel" v-if="userBridgeStore.showDetail" :style="{ zIndex: currentZIndex }">
    <div class="BasePannel-title">
      <span>桥梁信息</span>
      <el-icon @click="userBridgeStore.closeDetail" style="cursor: pointer" size="21">
        <CircleClose />
      </el-icon>
    </div>

    <div class="BasePannel-content">
      <el-descriptions :column="1" border>
        <el-descriptions-item :label="userBridgeStore.bridgeDetail?.bridge">
          <el-image style="width: 100%" :src="userBridgeStore.bridgeDetail?.bridgePhoto" :zoom-rate="1.2" :max-scale="7"
            :min-scale="0.2" fit="cover" :preview-src-list="
              userBridgeStore.bridgeDetail ? [userBridgeStore.bridgeDetail.bridgePhoto] : []
            " show-progress preview-teleported />
        </el-descriptions-item>
        <el-descriptions-item label="建成时间（年份）">{{
          userBridgeStore.bridgeDetail?.completionTime
          }}</el-descriptions-item>
        <el-descriptions-item label="设计最高通航水位（m）">{{
          userBridgeStore.bridgeDetail?.designHighestNavigableWaterLevel
          }}</el-descriptions-item>
        <el-descriptions-item label="设计最高通航水位重现期（年）">{{
          userBridgeStore.bridgeDetail?.designHighestNavigableWaterLevelReturnPeriod
          }}</el-descriptions-item>
        <el-descriptions-item label="结构型式">{{
          userBridgeStore.bridgeDetail?.structuralType
          }}</el-descriptions-item>
        <el-descriptions-item label="朝向">{{
          userBridgeStore.bridgeDetail?.face
          }}</el-descriptions-item>
        <el-descriptions-item label="所属航段">{{
          userBridgeStore.bridgeDetail?.leg
          }}</el-descriptions-item>

        <el-descriptions-item label="长度（m）">{{
          userBridgeStore.bridgeDetail?.length
          }}</el-descriptions-item>
        <el-descriptions-item label="主桥长度（m）">{{
          userBridgeStore.bridgeDetail?.mainBridgeLength
          }}</el-descriptions-item>
        <el-descriptions-item label="实际净宽（m）">
          <!-- <span> 左孔： {{ userBridgeStore.bridgeDetail?. }}</span> -->
          <span> 右孔： {{ userBridgeStore.bridgeDetail?.actualClearWidthRightSpan }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="实际净高（m）">
          <span> 左孔：{{ userBridgeStore.bridgeDetail?.actualClearHeightLeftSpan }} </span>
          <br />
          <span> 右孔：{{ userBridgeStore.bridgeDetail?.actualClearHeightRightSpan }} </span>
        </el-descriptions-item>
        <el-descriptions-item label="通航孔跨距（m）">
          <span> 左孔： {{ userBridgeStore.bridgeDetail?.navigableSpanLengthLeftSpan }}</span>
          <br />
          <span> 右孔：{{ userBridgeStore.bridgeDetail?.navigableSpanLengthRightSpan }} </span>
        </el-descriptions-item>
        <el-descriptions-item label="最高通航水位（m）">{{
          userBridgeStore.bridgeDetail?.highestNavigableWaterLevel
          }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted } from 'vue'
import { CircleClose } from '@element-plus/icons-vue'

import { useBridgeStore } from '@/stores/bridge'
const userBridgeStore = useBridgeStore()

// 全局弹窗层级计数器
let currentZIndex = ref(10)

// 获取 .cesium-popup 的最大 z-index
const getCesiumPopupMaxZIndex = () => {
  const popups = document.querySelectorAll('.cesium-popup')
  let maxZIndex = 0
  popups.forEach((popup) => {
    const zIndex = parseInt(window.getComputedStyle(popup).zIndex || '0', 10)
    if (zIndex > maxZIndex) {
      maxZIndex = zIndex
    }
  })
  return maxZIndex
}

// 动态设置 BasePannel 的 z-index
const updateBasePannelZIndex = () => {
  const maxPopupZIndex = getCesiumPopupMaxZIndex()
  currentZIndex.value = maxPopupZIndex + 1
}

onMounted(() => {
  updateBasePannelZIndex()
})

watch(
  () => userBridgeStore.bridgeId,
  (newId) => {
    updateBasePannelZIndex()
  }
)
</script>

<style lang="scss" scoped>
.BasePannel {
  width: 360px;
  position: absolute;
  top: calc(40px + 24px);
  right: 16px;
  bottom: 16px;

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  background-color: rgba(256, 256, 256, 0.5); /* 半透明背景 */
  backdrop-filter: blur(10px); /* 应用模糊效果 */
  border-radius: 6px;
  padding: 16px;
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    position: relative;
    > span {
      color: #000;
      font-weight: bold;
    }
  }

  &-content {
    flex: 1;
    height: calc(100% - 24px + 16px - 16px * 2);
    overflow: hidden;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 8px; /* 滚动条宽度 */
      height: 8px; /* 横向滚动条高度 */
    }
    ::-webkit-scrollbar-track {
      background: #f1f1f1; /* 滚动条轨道背景色 */
    }

    ::-webkit-scrollbar-thumb {
      background: #ddd; /* 滚动条滑块背景色 */
      border-radius: 4px; /* 滚动条滑块圆角 */
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #ccc; /* 滚动条滑块悬停背景色 */
    }

    ::-webkit-scrollbar-button {
      display: none; /* 隐藏滚动条按钮 */
    }
    scrollbar-width: thin; /* 设置滚动条宽度为细 */
    scrollbar-color: #ddd #f1f1f1; /* 滚动条滑块和轨道颜色 */
  }
}

:deep(.el-descriptions__cell) {
  font-size: 12px !important;
}
:deep(.is-bordered-label) {
  width: 45%;
}
</style>
